import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/login/Login'
import Logout from '@/components/login/Logout'
import ActivateUser from '@/components/login/ActivateUser'
import AcceptInvitation from '@/components/login/AcceptInvitation'

import News from '@/components/news/News'
import NutrieducNews from '@/components/news/NutrieducNews'
import SHDLNews from '@/components/news/SHDLNews'

import NutriKiosk from '@/components/nutrikiosk/NutriKiosk'

import Tools from '@/components/tools/Tools'
import IMC from '@/components/tools/IMC'
import IMCWeightLossCalc from '@/components/tools/IMCWeightLossCalc'

import UsersManager from '@/components/users/UsersManager'
import User from '@/components/users/User'
import UserHistory from '@/components/users/UserHistory'
import UserAttributeCharts from '@/components/users/UserAttributeCharts'

import FitbitAuthorized from '@/components/fitbit/FitbitAuthorized'

import UserMealSurveys from '@/components/meals/UserMealSurveys'
import UserMealElements from '@/components/meals/UserMealElements'

import NutriEduc from '@/components/nutrieduc/NutriEduc'
import MealAssessment from '@/components/nutrieduc/MealAssessment'
import Favorites from '@/components/nutrieduc/Favorites'

import Coaching from '@/components/coaching/Coaching'
import CoachedUserWorkspace from '@/components/coaching/CoachedUserWorkspace'

import ShdlUserModules from '@/components/shdl/ShdlUserModules'
import ShdlModule from '@/components/shdl/ShdlModule'
import ShdlEditor from '@/components/shdl/ShdlEditor'
import ShdlSimulator from '@/components/shdl/ShdlSimulator'
import ShdlDoc from '@/components/shdl/ShdlDoc'

import CrapsUserModules from '@/components/craps/CrapsUserModules'
import CrapsModule from '@/components/craps/CrapsModule'
import CrapsEditor from '@/components/craps/CrapsEditor'
import CrapsSimulator from '@/components/craps/CrapsSimulator'
import CrapsDoc from '@/components/craps/CrapsDoc'

import Messages from '@/components/messages/Messages'

import SalutanceNews from '@/components/salutance/SalutanceNews'

import UserSurveys from '@/components/surveys/UserSurveys'
import SurveyAnswers from '@/components/surveys/SurveyAnswers'

import QCUEditor from '@/components/nutrikiosk/QCUEditor'
import QCUQuestion from '@/components/nutrikiosk/QCUQuestion'

import { verifyToken } from '@/utilities/jwtToken.js'

import store from "@/store/index.js"
import config from '@/config'

Vue.use(Router)


const router = new Router({
   mode: 'hash',
   base: '/',
   routes: [
      // path='/': see navigation guard at end of file
      {
         path: '/news',
         name: 'news',
         component: News,
         children: [
            {
               path: 'nutrieduc',
               name: 'nutrieduc-news',
               component: NutrieducNews,
            },
            {
               path: 'shdl',
               name: 'shdl-news',
               component: SHDLNews,
            },
         ],
      },
      {
         path: '/login',
         name: 'login',
         component: Login,
      },
      {
         path: '/logout',
         name: 'logout',
         component: Logout,
      },
      {
         path: '/fitbit-authorized',
         name: '/fitbit-authorized',
         component: FitbitAuthorized,
      },
      {
         path: '/activate-user',
         name: 'ActivateUser',
         component: ActivateUser,
      },
      {
         path: '/accept-invitation',
         name: 'AcceptInvitation',
         component: AcceptInvitation,
         props: (route) => ({
            acceptInvitationUrl: config.ACCEPT_INVITATION_URL,
            token: route.query.token,
         }),
      },


      {
         path: '/nutrikiosk',
         name: 'nutrikiosk',
         component: NutriKiosk,
      },
      {
         path: '/tools',
         name: 'tools',
         component: Tools,
      },
      {
         path: '/imc',
         name: 'imc',
         component: IMC,
      },
      {
         path: '/imc-weightloss-calc',
         name: 'imc-weightloss-calc',
         component: IMCWeightLossCalc,
      },

      {
         path: '/qcu-editor',
         name: 'qcu-editor',
         component: QCUEditor,
         props: (route) => ({
            baseRoute: '/qcu-editor/',
         }),
         children: [
            {
               path: 'question/:questionId',
               name: 'question-detail',
               component: QCUQuestion,
               // props: true wouldn't convert userId string into int
               props: (route) => ({
                  questionId: parseInt(route.params.questionId),
               }),
            },
            {
               path: 'create',
               name: 'question-create',
               component: QCUQuestion,
               props: (route) => ({
                  questionId: 0,
               }),
            },
         ],
      },

      //////////////////////////////////     USER MANAGEMENT     //////////////////////////////////

      {
         path: '/user-manager',
         name: 'UsersManager',
         component: UsersManager,
         children: [
            {
               path: 'user/:userId',
               name: 'user-detail',
               component: User,
               // props: true wouldn't convert userId string into int
               props: (route) => ({
                  userId: parseInt(route.params.userId),
               }),
            },
            {
               path: 'create',
               name: 'UserCreate',
               component: User,
               props: (route) => ({
                  userId: 0,
                  message: route.query.message,
               }),
            },
         ],
      },

      //////////////////////////////////     SALUTANCE & DIAMOND COACHING      //////////////////////////////////

      {
         path: '/nutritional-coaching/:realm',
         name: 'nutritional-coaching',
         component: Coaching,
         props: (route) => ({
            title: "Patients",
            baseRoute: `/nutritional-coaching/${route.params.realm}/`,
         }),
         children: [
            {
               path: ':userId',
               name: 'nutritional-user-workspace',
               component: CoachedUserWorkspace,
               props: (route) => ({
                  userId: parseInt(route.params.userId),
                  realm: route.params.realm,
                  items: store.getters.authorized[`${route.params.realm}-coaching`]['items'],
                  baseRoute: `/nutritional-coaching/${route.params.realm}/${route.params.userId}/`,
               }),
               children: [
                  {
                     path: 'food-surveys',
                     name: 'nutritional-coaching-surveys',
                     component: UserMealSurveys,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                        baseRoute: `/nutritional-coaching/${route.params.realm}/${route.params.userId}/food-surveys/`,
                     }),

                     children: [
                        {
                           path: ':date/:index',
                           name: 'nutritional-coaching-surveys-meal',
                           components: {
                              mealElements: UserMealElements,
                              favorites: Favorites,
                           },
                           props: {
                              mealElements: (route) => {
                                 return {
                                    userId: parseInt(route.params.userId),
                                    date: route.params.date,
                                    index: parseInt(route.params.index),
                                 }
                              },
                              favorites: (route) => {
                                 return {
                                    userId: parseInt(route.params.userId),
                                    index: parseInt(route.params.index),
                                 }
                              },
                           },
                        }
                     ],
            
                  },
                  {
                     path: 'nutrieduc',
                     name: 'nutritional-nutrieduc',
                     component: NutriEduc,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                        baseRoute: `/nutritional-coaching/${route.params.realm}/${route.params.userId}/nutrieduc/`,
                     }),
                     children: [
                        {
                           path: ':date/:index',
                           name: 'nutritional-nutrieduc-meal',
                           components: {
                              mealElements: UserMealElements,
                              favorites: Favorites,
                              mealAssessment: MealAssessment,
                           },
                           props: {
                              mealElements: (route) => {
                                 return {
                                    userId: parseInt(route.params.userId),
                                    date: route.params.date,
                                    index: parseInt(route.params.index),
                                 }
                              },
                              favorites: (route) => {
                                 return {
                                    userId: parseInt(route.params.userId),
                                    index: parseInt(route.params.index),
                                 }
                              },
                              mealAssessment: (route) => {
                                 return {
                                    userId: parseInt(route.params.userId),
                                    date: route.params.date,
                                    index: parseInt(route.params.index),
                                 }
                              },
                           },
                        }
                     ],
                  },
                  {
                     path: 'surveys',
                     name: 'nutritional-surveys',
                     component: UserSurveys,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                        baseRoute: `/nutritional-coaching/${route.params.realm}/${route.params.userId}/surveys/`,
                        mode: 'caregiver',
                     }),
                     children: [
                        {
                           path: ':userSurveyId',
                           name: 'nutritional-survey-answers',
                           component: SurveyAnswers,
                           props: (route) => ({
                              userSurveyId: parseInt(route.params.userSurveyId),
                              baseRoute: `/nutritional-coaching/${route.params.realm}/${route.params.userId}/surveys/${route.params.userSurveyId}/`,
                              mode: 'caregiver',
                           }),
                        },
                     ],
                  },
                  {
                     path: 'indicators',
                     name: 'nutritional-indicators',
                     component: UserAttributeCharts,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                     }),
                  },
                  {
                     path: 'messages',
                     name: 'nutritional-messages',
                     component: Messages,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                     }),
                  },
               ],
            },
         ],
      },

      //////////////////////////////////     USER FOOD SURVEYS (Salutance, Diamond)     //////////////////////////////////
      
      {
         path: '/food-surveys',
         name: 'food-surveys',
         component: UserMealSurveys,
         // props: true wouldn't convert userId string into int
         props: (route) => ({
            userId: store.state.loggedUserId,
            baseRoute: '/food-surveys/',
         }),

         children: [
            {
               path: ':date/:index',
               name: 'food-surveys-meal',
               components: {
                  mealElements: UserMealElements,
                  favorites: Favorites,
               },
               props: {
                  mealElements: (route) => {
                     return {
                        userId: store.state.loggedUserId,
                        date: route.params.date,
                        index: parseInt(route.params.index),
                     }
                  },
                  favorites: (route) => {
                     return {
                        userId: store.state.loggedUserId,
                        index: parseInt(route.params.index),
                     }
                  },
               },
            }
         ],
      },

      //////////////////////////////////     MY PROFILE (Salutance)     //////////////////////////////////
      
      {
         path: '/my-profile',
         name: 'my-profile',
         component: User,
         props: (route) => ({
            userId: store.state.loggedUserId,
         }),
      },


      //////////////////////////////////     USER ATTRIBUTES (Salutance, Diamond)     //////////////////////////////////
      
      {
         path: '/user-attributes',
         name: 'user-attributes',
         component: UserAttributeCharts,
         props: (route) => ({
            userId: store.state.loggedUserId,
         }),
      },


      //////////////////////////////////     NUTRI-EDUC (Salutance)     //////////////////////////////////
      
      {
         path: '/nutrieduc',
         name: 'nutrieduc',
         component: NutriEduc,
         props: (route) => ({
            userId: store.state.loggedUserId,
            baseRoute: '/nutrieduc',
         }),
         children: [
            {
               path: ':date/:index',
               name: 'nutrieduc-date-index',
               components: {
                  mealElements: UserMealElements,
                  mealAssessment: MealAssessment,
                  favorites: Favorites,
               },
               props: {
                  mealElements: (route) => {
                     return {
                        userId: store.state.loggedUserId,
                        date: route.params.date,
                        index: parseInt(route.params.index),
                     }
                  },
                  favorites: (route) => {
                     return {
                        userId: store.state.loggedUserId,
                        index: parseInt(route.params.index),
                     }
                  },
                  mealAssessment: (route) => {
                     return {
                        userId: store.state.loggedUserId,
                        date: route.params.date,
                        index: parseInt(route.params.index),
         }
                  },
               },
            }
         ],
      },

      
      //////////////////////////////////     NUTRITION QUESTION SURVEYS      //////////////////////////////////

      {
         path: '/survey-coaching',
         name: 'survey-coaching',
         component: Coaching,
         props: (route) => ({
            title: "Patients",
            baseRoute: '/survey-coaching/',
         }),
         children: [
            {
               path: ':userId',
               name: 'survey-user-workspace',
               component: CoachedUserWorkspace,
               props: (route) => ({
                  userId: parseInt(route.params.userId),
                  items: store.getters.authorized['survey-coaching']['items'],
                  baseRoute: `/survey-coaching/${route.params.userId}/`,
               }),
               children: [
                  {
                     path: 'surveys',
                     name: 'ritz-surveys',
                     component: UserSurveys,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                        baseRoute: `/survey-coaching/${route.params.userId}/surveys/`,
                        mode: 'caregiver',
                     }),
                     children: [
                        {
                           path: ':userSurveyId',
                           name: 'ritz-survey-answers',
                           component: SurveyAnswers,
                           props: (route) => ({
                              userSurveyId: parseInt(route.params.userSurveyId),
                              baseRoute: `/survey-coaching/${route.params.userId}/surveys/${route.params.userSurveyId}/`,
                              mode: 'caregiver',
                           }),
                        },
                     ],
                  },
                  {
                     path: 'messages',
                     name: 'survey-messages',
                     component: Messages,
                     props: (route) => ({
                        userId: parseInt(route.params.userId),
                     }),
                  },
               ],
            },
         ],
      },
      
      {
         path: '/user-surveys',
         name: 'user-surveys',
         component: UserSurveys,
         // props: true wouldn't convert userId string into int
         props: (route) => ({
            userId: store.state.loggedUserId,
            baseRoute: '/user-surveys/',
            mode: 'patient',
         }),
         children: [
            {
               path: ':userSurveyId',
               name: 'user-survey',
               component: SurveyAnswers,
               props: (route) => ({
                  userSurveyId: parseInt(route.params.userSurveyId),
                  baseRoute: `/user-surveys/${route.params.userSurveyId}/`,
                  mode: 'patient',
               }),
            },
         ],
      },

      //////////////////////////////////     MESSAGES     //////////////////////////////////
      
      {
         path: '/messages',
         name: 'messages',
         component: Messages,
         // props: true wouldn't convert userId string into int
         props: (route) => ({ userId: store.state.loggedUserId }),
      },

      //////////////////////////////////     SHDL     //////////////////////////////////

      {
         path: '/shdl-doc',
         name: 'ShdlDoc',
         component: ShdlDoc,
      },
      {
         path: '/shdl-user-coaching',
         name: 'shdl-user-coaching',
         component: Coaching,
         props: (route) => ({
            title: "Élèves",
            baseRoute: '/shdl-user-coaching/',
         }),
         children: [
            {
               path: ':userId',
               name: 'shdl-user-workspace',
               component: CoachedUserWorkspace,
               props: (route) => ({
                  userId: parseInt(route.params.userId),
                  items: store.getters.authorized['shdl-user-coaching']['items'],
                  baseRoute: `/shdl-user-coaching/${route.params.userId}/`,
               }),
               children: [
                  {
                     path: 'shdl-sandbox',
                     name: 'user-shdl-modules',
                     component: ShdlUserModules,
                     props: (route) => ({
                       userId: parseInt(route.params.userId),
                       baseRoute: `/shdl-user-coaching/${route.params.userId}/shdl-sandbox/`,
                     }),
                     children: [
                        {
                           path: 'module/:moduleId',
                           name: 'user-shdl-module',
                           component: ShdlModule,
                           props: (route) => ({
                              moduleId: parseInt(route.params.moduleId),
                              baseRoute: `/shdl-user-coaching/${route.params.userId}/shdl-sandbox/module/${route.params.moduleId}/`,
                           }),
                           children: [
                              {
                                 path: 'editor',
                                 name: 'user-shdl-module-editor',
                                 component: ShdlEditor,
                                 props: (route) => ({
                                    module: store.state.shdl.modules[route.params.moduleId],
                                 }),
                              },
                              {
                                 path: 'simulator',
                                 name: 'user-shdl-module-simulator',
                                 component: ShdlSimulator,
                                 props: (route) => ({
                                    module: store.state.shdl.modules[route.params.moduleId],
                                 }),
                              },
                           ],
                        },
                     ],
                  },
                  {
                    path: 'messages',
                    name: 'shdl-coaching-messages',
                    component: Messages,
                    props: (route) => ({
                       userId: parseInt(route.params.userId),
                    }),
                 },
                 {
                  path: 'history',
                  name: 'shdl-coaching-history',
                  component: UserHistory,
                  props: (route) => ({
                     userId: parseInt(route.params.userId),
                  }),
               },
           ],
            },
         ],
      },
      {
         path: '/shdl-sandbox',
         name: 'shdl-sandbox',
         component: ShdlUserModules,
         props: (route) => ({
            userId: store.state.loggedUserId,
            baseRoute: '/shdl-sandbox/',
         }),
         children: [
            {
               path: 'module/:moduleId',
               name: 'shdl-sandbox-module',
               component: ShdlModule,
               props: (route) => ({
                  moduleId: parseInt(route.params.moduleId),
                  baseRoute: `/shdl-sandbox/module/${route.params.moduleId}/`,
               }),
               children: [
                  {
                     path: 'editor',
                     name: 'shdl-sandbox-module-editor',
                     component: ShdlEditor,
                     props: (route) => ({
                        module: store.state.shdl.modules[route.params.moduleId],
                     }),
                  },
                  {
                     path: 'simulator',
                     name: 'shdl-sandbox-module-simulator',
                     component: ShdlSimulator,
                     props: (route) => ({
                        module: store.state.shdl.modules[route.params.moduleId],
                     }),
                  },
               ],
            },
         ],
      },

      //////////////////////////////////     CRAPS     //////////////////////////////////

      {
         path: '/craps-doc',
         name: 'craps-doc',
         component: CrapsDoc,
      },
      {
         path: '/craps-user-coaching',
         name: 'craps-user-coaching',
         component: Coaching,
         props: (route) => ({
            title: "Élèves",
            baseRoute: '/craps-user-coaching/',
         }),
         children: [
            {
               path: ':userId',
               name: 'craps-user-workspace',
               component: CoachedUserWorkspace,
               props: (route) => ({
                  userId: parseInt(route.params.userId),
                  items: store.getters.authorized['craps-user-coaching']['items'],
                  baseRoute: `/craps-user-coaching/${route.params.userId}/`,
               }),
               children: [
                  {
                     path: 'craps-sandbox',
                     name: 'user-craps-modules',
                     component: CrapsUserModules,
                     props: (route) => ({
                       userId: parseInt(route.params.userId),
                       baseRoute: `/craps-user-coaching/${route.params.userId}/craps-sandbox/`,
                     }),
                     children: [
                        {
                           path: 'module/:moduleId',
                           name: 'user-craps-module',
                           component: CrapsModule,
                           props: (route) => ({
                              moduleId: parseInt(route.params.moduleId),
                              baseRoute: `/craps-user-coaching/${route.params.userId}/craps-sandbox/module/${route.params.moduleId}/`,
                           }),
                           children: [
                              {
                                 path: 'editor',
                                 name: 'user-craps-module-editor',
                                 component: CrapsEditor,
                                 props: (route) => ({
                                    module: store.state.craps.modules[route.params.moduleId],
                                 }),
                              },
                              {
                                 path: 'simulator',
                                 name: 'user-craps-module-simulator',
                                 component: CrapsSimulator,
                                 props: (route) => ({
                                    module: store.state.craps.modules[route.params.moduleId],
                                 }),
                              },
                           ],
                        },
                     ],
                  },
                  {
                    path: 'messages',
                    name: 'craps-coaching-messages',
                    component: Messages,
                    props: (route) => ({
                       userId: parseInt(route.params.userId),
                    }),
                 },
                 {
                  path: 'history',
                  name: 'craps-coaching-history',
                  component: UserHistory,
                  props: (route) => ({
                     userId: parseInt(route.params.userId),
                  }),
               },
           ],
            },
         ],
      },
      {
         path: '/craps-sandbox',
         name: 'craps-sandbox',
         component: CrapsUserModules,
         props: (route) => ({
            userId: store.state.loggedUserId,
            baseRoute: '/craps-sandbox/',
         }),
         children: [
            {
               path: 'module/:moduleId',
               name: 'craps-sandbox-module',
               component: CrapsModule,
               props: (route) => ({
                  moduleId: parseInt(route.params.moduleId),
                  baseRoute: `/craps-sandbox/module/${route.params.moduleId}/`,
               }),
               children: [
                  {
                     path: 'editor',
                     name: 'craps-sandbox-module-editor',
                     component: CrapsEditor,
                     props: (route) => ({
                        module: store.state.craps.modules[route.params.moduleId],
                     }),
                  },
                  {
                     path: 'simulator',
                     name: 'craps-sandbox-module-simulator',
                     component: CrapsSimulator,
                     props: (route) => ({
                        module: store.state.craps.modules[route.params.moduleId],
                     }),
                  },
               ],
            },
         ],
      },
      
   ]
})

const noAuthRouteNames = [
   'news', 'nutrieduc-news', 'shdl-news',
   'login', 'logout', 'ActivateUser', 'AcceptInvitation',
   'fitbit-authorized',
   'tools', 'imc', 'imc-weightloss-calc',
   'salutance-news',
   'nutrikiosk',
]

router.beforeEach((to, from, next) => {
   if (to.path === '/') {
      next('/news')
      
   } else if (noAuthRouteNames.indexOf(to.name) !== -1) {
      // theses routes don't need authentication
      next()

   } else {
      // these routes need valid authentication
      if (store.state.authenticationData) {
         try {
            verifyToken(store.state.authenticationData.token, store.state.authenticationData.publicKey)
            next()
         } catch(e) {
            // JWT probably expired, go to login page
            next('/login');
         }
      } else {
         console.log('JCB2 to', to, 'from', from)
         next(false);
      }
   }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js